import React from "react"

import Box from "@material-ui/core/Box"

import MainFotograps from "./MainPhotos"
import AdditionalPhotos from "./AdditionalPhotos"
import FilesOption from "./Files"
import { styles } from "./styles"
import ReviewPhotos from "./ReviewPhotos"

const TabPanel = (props) => {
  const { children, value, index } = props
  return (
    <div>
      {value === index && (
        <Box>
          <div>{children}</div>
        </Box>
      )}
    </div>
  )
}

const MostrarContenidoBox = (props) => {
  const classes = styles()

  return (
    <div className={classes.style}>
      <TabPanel TabPanel value={props.value} index={0}>
        <MainFotograps />
      </TabPanel>

      <TabPanel value={props.value} index={1}>
        <ReviewPhotos />
      </TabPanel>

      <TabPanel value={props.value} index={2}>
        <AdditionalPhotos />
      </TabPanel>

      <TabPanel value={props.value} index={3}>
        <FilesOption />
      </TabPanel>
    </div>
  )
}

export default MostrarContenidoBox
